package com.arena_web.data.repository

import com.arena_web.data.api.UserApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.UserRepository

class UserRepositoryImpl(private val userApi: UserApi) : UserRepository {

    override suspend fun getMe(): Result<UserDto> =
        apiCall { userApi.getMe() }

    override suspend fun updateMe(request: UpdateUserRequest): Result<UserDto> =
        apiCall { userApi.updateMe(request) }

    override suspend fun uploadMyAvatar(fileBytes: ByteArray, fileName: String, contentType: String): Result<UserDto> =
        apiCall { retryOnceOnNetworkError { userApi.uploadMyAvatar(fileBytes, fileName, contentType) } }

    override suspend fun updateActiveRole(request: UpdateActiveRoleRequest): Result<UserDto> =
        apiCall { userApi.updateActiveRole(request) }

    override suspend fun deleteMe(): Result<Unit> = runCatching {
        val status = userApi.deleteMe()
        val code = status.value
        if (code !in 200..299) {
            throw IllegalStateException("Account deletion failed: $code ${status.description}")
        }
    }

    override suspend fun getMySportProfile(sportId: String): Result<SportProfileDto> =
        apiCall { userApi.getMySportProfile(sportId) }

    override suspend fun getMySportProfileAggregate(): Result<SportProfileAggregateDto> =
        apiCall { userApi.getMySportProfileAggregate() }

    override suspend fun updateMySportProfile(sportId: String, request: UpdateSportProfileRequest): Result<SportProfileDto> =
        apiCall { userApi.updateMySportProfile(sportId, request) }

    override suspend fun getMyStatsChart(params: Map<String, String>): Result<StatsChartDto> =
        apiCall { userApi.getMyStatsChart(params) }

    override suspend fun getUser(userId: String): Result<UserDto> =
        apiCall { userApi.getUser(userId) }

    override suspend fun getSportProfile(userId: String, params: Map<String, String>): Result<SportProfileDto> =
        apiCall { userApi.getSportProfile(userId, params) }

    override suspend fun getSportProfileAggregate(userId: String): Result<SportProfileAggregateDto> =
        apiCall { userApi.getSportProfileAggregate(userId) }

    override suspend fun getUserStatsChart(userId: String, params: Map<String, String>): Result<StatsChartDto> =
        apiCall { userApi.getUserStatsChart(userId, params) }

    override suspend fun getUserTeams(userId: String): Result<List<TeamDto>> =
        apiCall { userApi.getUserTeams(userId) }

    override suspend fun getUserFavoriteMedia(userId: String): Result<List<EventMediaDto>> =
        apiCall { userApi.getUserFavoriteMedia(userId) }

    override suspend fun getUserPosts(userId: String, params: Map<String, String>): Result<UserPostPageDto> =
        apiCall { userApi.getUserPosts(userId, params) }

    override suspend fun getMyAwards(): Result<List<UserAwardDto>> =
        apiCall { userApi.getMyAwards() }

    override suspend fun getUserAwards(userId: String): Result<List<UserAwardDto>> =
        apiCall { userApi.getUserAwards(userId) }
}
